import ConditionType from './ConditionType'

const ChangedMoreThanCondition: ConditionType = {
  value: 'changed more than',
  label: 'Changed More Than',
  hasRHS: true,
  hasThreshold: true,
}

export default ChangedMoreThanCondition
